export default __webpack_public_path__ + "static/media/route-new.669133e3.png";